import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const BarContainer = styled.div`
    position: relative;
     grid-column: 1 / span 2;
    z-index: 1000;

    ${mq(Devices.tablet)} {
        grid-column: 1 / 1;
    }
`;

export const Container = styled.div`
    width:100%;
    background:#fff;
    border:1px solid #2a848e7b;
    padding:10px 16px;
    display:flex;
    align-items: center;
    gap:10px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.1s ease-in-out;

    > svg{
        margin-left: auto;
        width:12px;
        height:12px;
        path{
            fill:#8d8d8d;
        }
    }

    :hover{
        box-shadow: 0 0 2px 2px #2a848e42;
    }
`;

export const IconBox = styled.div`
    background:#2a848e3e;
    border-radius: 8px;
    width:32px;
    height:32px;
    display:flex;
    align-items: center;
    justify-content: center;

    svg{
        width:16px;
        height:16px;
        path{
            fill:#2a848e;
        }
    }
`;

export const ImageContainer = styled.div`
    height:32px;
    width:32px;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
`;

export const SearchBarText = styled.div`
    display:flex;
    flex-direction: column;
    height:30px;
    width:100%;

    span{
        font-weight: 500;
        :nth-of-type(1){
            font-size: 16px;
            line-height: 18px;
        }
        :nth-of-type(2){
            color:#999999;
            line-height: 14px;
        }
    }

    input{
        height: 100%;
        border:none;
        font-size: 14px;
        outline: None;
        color:#313131;
        width: 100%;
    }
`;

export const SearchPop = styled.div<{show:boolean}>`
    display: ${props => props.show?"block":"none"};
    position: absolute;
    top:66px;
    left:0;
    width:100%;
    background:#fff;
    box-shadow:0 0 2px 2px rgba(0,0,0,0.10);
    border-radius: 8px;
    border:1px solid #2a848e7b;
    overflow: hidden;
    min-height:180px;
`;

export const SearchArea = styled.div`
    border-bottom: 1px solid #c0c0c0;
    box-shadow: 0 0 2px 1px rgba(0,0,0,0.10);
    padding:10px 16px;
    display:flex;
    gap:8px;
    align-items: center;

    svg{
        width:16px;
        height:16px;
        path{
            fill:#8a8a8a;
        }
    }
`;

export const ResualtArea = styled.div`
    padding:10px 8px;
    max-height: 60vh;
    overflow-y: auto;
`;

export const ResualtItem = styled.div`
    
    padding:12px;
    display:flex;
    align-items: center;
    gap:12px;
    border-radius: 10px;
    margin-bottom: 4px;
    transition: all 0.1s ease-in-out;

    > div{
        height:44px;
        width:44px;
    }

    > span{
        font-size: 16px;
        font-weight: 500;
    }

    :hover{
        background:#2a848e24;
        cursor: pointer;

        > span{
            color:#2a848e;
        }
    }
    
`;

export const NoStudent = styled.div`
    padding:32px 0;
    display:flex;
    flex-direction: column;
    align-items: center;
    gap:8px;

    span{
        color:#313131;
        :nth-of-type(1){
            
            font-size: 18px;
        }
        :nth-of-type(2){
            font-size: 14px;
        }
    }
    svg{
        height:40px;
        width:40px;
        stroke{
            fill:#8a8a8a;
        }
    }
`;